import styled from 'styled-components';

const ContModal = styled.div`
position: fixed;
top:0;
right:0;
bottom:0;
left:0;
width:100%;
height:100%;
background: rgba(112, 112, 112, 0.38);
z-index:100000;
display: ${props=>props.d || 'none'};
justify-content:center;
align-items:center;
padding:10px;
overflow: auto;
`
const ModalProcess = styled.div`
display: flex;
flex-direction: column;
justify-content:flex-start;
align-items:center;
background-color: #ffffff;
border-radius:5px;
min-width:300px;
min-height: 500px;
margin-top:auto;
margin-bottom:auto;
width:80%;
`
const headerModal = styled.div`
padding:10px;
height: 60px;
width:100%;
background:#F5F5F6;
display: flex;
justify-content:flex-start;
align-items:center;
align-self: flex-start;
border-top-left-radius: 5px;
border-top-right-radius: 5px;
`
const bodyModal = styled.div`
width:100%;
min-width:300px;
display:flex;
flex-direction:column;
justify-content: center;
align-self:flex-start;
min-height: 400px;
max-height: 600px;
overflow-y: auto;
overflow-x: hidden;
::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}
/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
    background: #707070;
    border-radius: 50px;

}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #7367f0;
}
`;

const footerModal = styled.div`
padding:10px;
height: 60px;
width:100%;
display: flex;
justify-content:space-between;
align-items:center;
align-self: flex-end;
border-bottom-left-radius: 5px;
border-bottom-right-radius: 5px;
border-top:0.5px solid rgba(112, 112, 112, 0.5);
margin-top: auto;
`;
const btnCloseModal = styled.button`
width:38px;
height: 38px;
border-radius:50px;
border:none;
color: #ffffff;
background-color: #7367f0;
display:flex;
justify-content:center;
align-items:center;
outline:none !important;
cursor: pointer;
margin-right: auto;
`
const text = styled.p`
margin-bottom:  ${props=> props.mb || '0'};;
color: ${props=> props.cl || '#707070'};
font-size: ${props=> props.size || '12px'};
margin-left: ${props=> props.ml || '0'};
margin-right: ${props=> props.mr || '0'};
font-weight: ${props=> props.fw || 'lighter'};
margin-top: ${props=> props.mt || '0'};
`;
const btnActionFooter = styled.button`
border: 0.5px solid;
border-color: ${props=> props.bc || '#707070'};
background-color: ${props=> props.bgc || 'transparent'};
padding: 8px 16px;
font-size: 12pt;
margin-left: ${props=> props.ml || '0'};
color: ${props=> props.cl || '#707070'};
border-radius:5px;
font-weight:600;
outline:none !important;
`;

const contTable = styled.div`
min-width: 280px;
min-height: 350px;
width: 100%;
border: none;
border-radius: .428rem;
background-clip: border-box;
background: white;
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
margin-top: 10px;
align-self: center;
margin-left: 10px;
margin-right: 10px;
margin-bottom: 20px;
`;

const headerContTable = styled.div`
/* border: 1px solid red; */
width: 100%;
height: 60px;
border-top-left-radius: 0.5rem;
border-top-right-radius: 0.5rem;
display: flex;
justify-content: space-between;
flex-wrap: wrap-reverse;
align-items: center; 
padding: 10px;
@media screen and (max-width: 761px) {
    height: 110px;
    justify-content: center;
    align-items: space-between;
}
`;
const bodyContentTable =  styled.div`
min-height: 20px;
max-height: 600px;
height: 500px;
width: 100%;
/* border:1px solid red; */
overflow-y: auto;
overflow-x: auto;
/* width */
::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}
/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
    background: #707070;
    border-radius: 50px;

}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #7367f0;
}
`;
const footerContTable = styled.div`
/* border: 1px solid red; */
width: 100%;
height: 60px;
border-bottom-left-radius: 0.5rem;
border-bottom-right-radius: 0.5rem;
display: flex;
justify-content: flex-end;
align-items: center; 
padding-right: 10px;
padding-top: 10px;
`;

const contActionOne = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
min-width: 280px;
width: 350px;
/* border: 1px solid red; */
`;
const contActionTwo = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
min-width: 280px;
width: 350px;
/* border: 1px solid red; */
`;

const anotherCont = styled.div`
width: 100%;
display: flex;
justify-content: ${props => props.jc || 'center'};
align-items: ${props => props.ali || 'center'};
margin-top: ${props => props.top || '0px'};
padding-right: ${props => props.pr || '0px'};
padding-left: ${props => props.pl || '0px'};
`;
const tableData = styled.table`
width: 100%;
border-collapse: collapse;
position: relative;
`;
const tableDataThead = styled.thead`
position: sticky;
margin-top: 0px;
width: 100%;
`;
const tableDataTh = styled.th`
background: #f3f2f7;
height: 40px;
width: ${props => props.w || 'auto'};
text-align: left;
text-indent: 10px;
color:#707070;
text-transform: uppercase;
font-size: .857rem;
letter-spacing: .5px;
`;

const tableDataTbody = styled.tbody`
width: 100%;
`;

const tableDataTr = styled.tr`
border-top: 1px solid #ebe9f1;
height: auto;
max-height: 60px;
`;

const tableDataTd = styled.td`
background: white;
height: 40px;
width: ${props => props.w || 'auto'};
max-width: ${props => props.w || 'auto'};
text-align: ${props => props.ta || 'left'};
padding: 10px;
color:#707070;
font-size: 12pt;
overflow-wrap: break-word;
word-wrap: break-word;
hyphens: auto;
word-break: break-all;
`;

const tableDataTdImg = styled.td`
background: white;
height: auto;
width: 100%;
padding: 10px;
color:#707070;
font-size: 12pt;
`;

const contLoader = styled.div`
width: 100%;
height: 100%;
margin-top: auto;
margin-bottom: auto;
display: flex;
justify-content: center;
align-items: center;
padding: 10px;
.spinner-border {
    border: .25em solid #7367f0;
    border-right-color: transparent;
}
`;

const ContDataImgNotFound = styled.div`
background-image: url('/img-no-data.svg');
background-size: contain;
background-repeat: no-repeat;
background-position: center;
width: 500px;
height: 500px;
`

const btnActionIcon = styled.button`
width: 35px;
height: 35px;
outline: none !important;
border-radius: 50%;
border: none;
margin-left: 2.5px;
margin-right: 2.5px;
display: flex;
align-items: center;
justify-content: center;
background: transparent;
transition: all ease-out 0.2s;
color: rgb(112 112 112 / 45%);
&:hover{
    color: #7367F0;
}
`;
const selectCuston = styled.select`
    padding-left:10px;
    padding-right:10px;
    font-family: "Berlin Rounded";
    width: ${props => props.wd || '100%'};
    margin-left: ${props => props.ml || '0'};
    margin-right: ${props => props.mr || '0'};
    height: 38px;
    border-radius: .357rem;
    background: white;
    border: 1px solid #d8d6de;
    outline: none !important;
    font-family: "Berlin Rounded";
    font-weight: 300;
    font-size: 12px;
    color: #707070;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    ::placeholder {
        font-family: "Berlin Rounded";
        font-weight: 300;
        font-size: 12px;
        color: rgba(112, 112, 112, 0.61);
        }
        &:focus {
            border: 0.5px solid rgba(115, 103, 240, 0.7);
            box-shadow: 0 3px 10px 0 rgb(34 41 47 / 10%);
        }
        @media(max-width: ${props => props.selectMq || '989px'}) {
        width:100%;
    }
`;

const input = styled.input`
    width: ${props => props.w || '100%'};
    height: 38px;
    border-radius: .357rem;
    background: #fff;
    box-shadow: 0 3px 10px 0 rgb(34 41 47 / 10%);
    border: 1px solid #d8d6de;
    outline: none !important;
    padding:6px 16px;
    font-size:12pt;
    color: rgb(112, 112, 112);
    font-weight: 600;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    ::placeholder {
        font-family: "Berlin Rounded";
        font-weight: 300;
        font-size: 12px;
        color: rgba(112, 112, 112, 0.61);
        }
        &:focus, &:active {
            border: 0.5px solid rgba(115, 103, 240, 0.7);
            box-shadow: 0 3px 10px 0 rgb(34 41 47 / 10%);
        }
    margin-top : ${props => props.mt || 0};
`;

const ContIcon = styled.span`
font-size: 20pt;
display: flex;
justify-content: center;
align-items: center;
color: ${props=> props.color || '#ea5455'};
svg {
    path {
        stroke: ${props=> props.color || '#ea5455'};
    }
}
`;
const OfflineProccesStyle =
{
    ContModal,
    ModalProcess,
    headerModal,
    bodyModal,
    footerModal,
    btnCloseModal,
    text,
    btnActionFooter,
    contTable,
    headerContTable,
    bodyContentTable,
    input,
    selectCuston,
    btnActionIcon,
    footerContTable,
    contActionOne,
    contActionTwo,
    anotherCont,
    tableData,
    tableDataThead,
    tableDataTh,
    tableDataTbody,
    tableDataTr,
    tableDataTd,
    contLoader,
    ContIcon,
    ContDataImgNotFound,
    tableDataTdImg
}
export default OfflineProccesStyle;